import { render } from "./MiNTNewsMobile.vue?vue&type=template&id=774fc6b5&scoped=true"
import script from "./MiNTNewsMobile.vue?vue&type=script&lang=js"
export * from "./MiNTNewsMobile.vue?vue&type=script&lang=js"

import "./MiNTNewsMobile.vue?vue&type=style&index=0&id=774fc6b5&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-774fc6b5"]])

export default __exports__